import React from "react";
import { TextField, Grid, Typography } from "@material-ui/core";
import { ace } from "../theme";

const OriginAddressStep = ({ value, onChange, submitted }) => (
  <div>
    <Typography variant="h5" style={{ color: ace.black, fontWeight: 700, marginBottom: 8 }}>
      Where we&apos;re moving you from
    </Typography>
    <Typography variant="body2" style={{ color: ace.muted, marginBottom: 24 }}>
      Origin address — line 1, city, state, and PIN help us plan.
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="Address line 1"
          value={value.originAddress1}
          onChange={(e) => onChange("originAddress1", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          label="Address line 2"
          value={value.originAddress2}
          onChange={(e) => onChange("originAddress2", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="City"
          value={value.originCity}
          onChange={(e) => onChange("originCity", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="State"
          value={value.originState}
          onChange={(e) => onChange("originState", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          label="PIN code"
          value={value.originPincode}
          onChange={(e) => onChange("originPincode", e.target.value)}
          disabled={submitted}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="Country"
          value={value.originCountry}
          onChange={(e) => onChange("originCountry", e.target.value)}
          placeholder="India"
          disabled={submitted}
        />
      </Grid>
    </Grid>
  </div>
);

export default OriginAddressStep;
